<template>
	<div class="paytype">
		<leftnav class="fl"></leftnav>
		<div class="index_left" :style="isCollapse ? 'margin-left: 0;width:100%' : ''">
			<govheader></govheader>
			<div class="index_left_centerpage">
				<div class="whitebox pb-3">
					<div class="widthPC-90 margin-x-auto">
						<div class="border-bottom  p-5">
							<p class="secessfont redfont-1 font-weight">订单提交成功，请尽快支付</p>
							<table border="0">
								<tr>
									<th>订单编号</th>
									<td>{{ alipayData.id }}</td>
								</tr>
								<tr>
									<th>订单内容</th>
									<td>{{curWebsite.shortname}} -{{ alipayData.title }} &nbsp;&nbsp;&nbsp;&nbsp; {{ alipayData.years }} 年使用时长</td>
								</tr>
								<tr>
									<th>联系手机</th>
									<td>{{ alipayData.mobile }}</td>
								</tr>
								<tr>
									<th>订单金额</th>
									<td class="font-bold">￥{{ alipayData.price }}</td>
								</tr>
								<tr>
									<th>订单状态</th>
									<td class="redfont-1 font-bold">{{ alipayData.status }}</td>
								</tr>
							</table>
						</div>
						<p class="bluetitle">选择支付方式</p>

						<div class="flexcss widthPC-50 margin-x-auto p-5">
							<div class="wxpay" @click="wxPay()">
								<svg t="1725431223663" class="icon" viewBox="0 0 1024 1024" version="1.1"
									xmlns="http://www.w3.org/2000/svg" p-id="10162" width="150" height="150">
									<path
										d="M379.8 843.4h124.8v12.4h-124.8zM379.8 878h124.8v13.2h-124.8zM501.6 981.8v-68.2h-118.6v68.2h118.6z m-13.2-55.8v43.6h-92.2V926h92.2zM347 988.8v-154.4c7-15.2 13.2-31.2 18.2-47.8l0.2-0.4-12.2-7-0.2 0.8c-11 38.6-26.8 73.2-46.8 102.6l-0.2 0.4 7.2 12.6 0.6-0.8c6.6-9.8 13.6-21.2 20-33v127.6h13.2zM802.4 779.6c-11 38.6-26.8 73.2-47 102.6l-0.2 0.4 7.2 12.6 0.6-0.8c6.6-9.8 13.6-21.2 20-33v127.6h13.2v-154.4c7-15 13.2-31.2 18.2-47.8l0.2-0.4-12.2-7v0.2zM453.2 804.2l-0.4-0.8c-0.8-2-3-6.4-5.6-12-2.2-4.6-4.6-9.6-5.8-12.2l-0.4-1-12.2 7 0.4 0.8c4 7.4 7.2 14.2 10.4 20.8l0.6 1.2h-72.4v13.2h150V808h-71l6.4-3.8zM198.6 798.8h-12.4v39h-19.6v-55.4h-12.4v55.4H133.6v-39h-12.2v51.4h77.2zM124.8 870.8h68.6v12.4H124.8zM169.6 955.2l-0.4 0.6 7.4 12.8 0.8-0.8c6-4.8 16.2-13.6 30.2-26l0.6-0.6-6.2-10.8-16.6 14.2v-41h-58v17.4c1.6 22.8-4 39.2-16.8 48.4l-0.8 0.6 6.4 11.2 0.6 1 0.8-0.8c16.4-13.4 24-32.4 22.8-56.2V916h32.8v24c-0.4 8.6-0.8 11.2-3.6 15.2zM74.2 847.4c17.2-17.2 32-38.2 43-60.4l0.2-0.6-11.4-6.6-0.2 0.6c-10.6 21.6-24.2 40.6-39 54.4l-0.4 0.4 7.4 12.8 0.4-0.6zM70.4 917.2l0.8-1c6.2-7.2 12.2-14.8 18-22.4v95h12.4v-115c5-9 9.8-18.8 14.4-29.6l0.4-0.8-11.8-6.8-0.4 1c-10.2 25.6-23.8 48-40.2 67l-0.4 0.6 6.4 11 0.4 1z"
										fill="#222222" p-id="10163"></path>
									<path
										d="M196.2 866.6l7.8 13.4 5.6-11.2c1.4-2.6 2.8-4.8 3.8-6.8 3.4 28.8 9.4 52.2 17.6 69.4-8.2 14-20.6 28.4-37 43l-0.6 0.6 7.2 12.6 0.8-0.8c17.2-16 29.2-30.2 35.8-42 7.4 12.8 19.6 28.4 33.6 42.6l0.8 1 7.4-12.8-0.6-0.6c-15.2-14.6-27.4-29.6-34.2-42.6 12.4-23 20.2-56.4 23.2-99.4h12.2v-12.4h-49c3.8-11.6 8.8-27 10.6-40v-0.6H228.4l-0.2 0.4c-7.2 33.8-18 62.8-32.2 86l0.2 0.2z m26.6-24.2c1-3.2 2.4-6.4 4-9.6h28.6c-2.2 35-8 63.2-17 84-7-18.6-12.2-43.6-15.6-74.4z m7.2-21.2zM648 778h-13.4v30h-93.6v13h93.6v38.2H574v11.6c0 0.2 9.6 21.4 28.2 44 8.8 10.8 17.6 19.6 27.4 27.6-26 15.8-52.6 26.2-84 32.2l-0.8 0.2 7.4 12.8 0.2 0.4h0.4c0.4 0 44.2-9.6 87.2-37.4 0.6 0.4 1.4 1 2.4 1.6 9.8 6.8 35.8 24.8 80.6 35.4l0.8 0.2 5.4-10.4-0.8-0.2c-0.2 0-13.2-3.4-32.6-11-11.8-4.6-29.2-12.4-46.4-23.8 26.4-19.8 46.8-46.2 58.8-76.8l0.2-0.6-10.4-6h-50v-38.2h94.6V808H648v-30z m45 92.8c-2.2 5.4-15.8 36.6-53 63.2-22.2-17-40.8-39.4-52.6-63.2h105.6zM927.8 831.4v-51.2h-13.2v51.2H816v13.2h98.6v110.4c0 11.6-6.8 17.2-21 17.2H886v13.2h11c11.2 0 18.2-2.2 23.6-7.6 5-5 7.4-12.6 7-22.6v-110.4H960v-13.2h-32.2z"
										fill="#222222" p-id="10164"></path>
									<path
										d="M854 874.8l-0.2-0.6-12 7 0.2 0.6c7.2 14.2 15.4 31.6 24.4 51.8l0.2 0.6 13-7.6-0.2-0.6c-6.8-13.8-15.6-31.4-25.4-51.2z"
										fill="#222222" p-id="10165"></path>
									<path
										d="M424.6 392c-2.8 1.4-6.2 2.4-9.6 2.4-8 0-15-4.4-18.6-11l-1.4-3-58.4-128.2c-0.6-1.4-1-3-1-4.6 0-6 4.8-10.6 10.6-10.6 2.4 0 4.6 0.8 6.4 2.2l69 49c5 3.2 11 5.2 17.6 5.2 3.8 0 7.6-0.8 11-2L774 147.2C716 78.8 620.2 34 512 34 334.8 34 191.2 153.6 191.2 301.4c0 80.6 43.2 153 110.8 202 5.4 3.8 9 10.2 9 17.4 0 2.4-0.6 4.6-1.2 6.8-5.4 20.2-14 52.4-14.4 54-0.6 2.6-1.8 5.2-1.8 7.8 0 6 4.8 10.6 10.6 10.6 2.4 0 4.2-0.8 6.2-2l70.2-40.6c5.2-3 10.8-5 17-5 3.2 0 6.4 0.4 9.4 1.4 32.8 9.4 68.2 14.6 104.8 14.6 177.2 0 320.8-119.8 320.8-267.4 0-44.8-13.2-86.8-36.6-123.8L426.8 390.8l-2.2 1.2z"
										fill="#22AC38" p-id="10166"></path>
								</svg>
							</div>
							<div class="alipay" @click="alipay">
								<svg t="1725431291415" class="icon" viewBox="0 0 1024 1024" version="1.1"
									xmlns="http://www.w3.org/2000/svg" p-id="18139" width="150" height="150">
									<path
										d="M670.2 344.4c61.8 20.8 76.6 21.8 76.6 21.8V143.4c0-38.2-31.4-68.8-68.8-68.8H384.8c-38.2 0-69.6 30.4-69.6 68.8v292.4c0 38.2 31.4 68.8 68.8 68.8h293.2c38.2 0 68.8-30.4 68.8-68.8v-2.6s-112.2-47-168.8-74C538.8 406.2 490 434 438.8 434c-50.4 0-86.2-29.6-90.4-60 0 0-11.4-32.2 15.6-64.4 8.8-10.4 24.4-20.8 47.8-27 36.6-8.8 94.8 5.2 149.6 23.4 9.6-18.2 18.2-38.2 24.4-59.2h-168.8v-17.4H504V199h-104.4v-17.4h105.2V138.2s0-7 7.8-7h42.6v51.4h104.4v17.4h-104.4v30.4h85.2c-7.8 33-20.8 63.6-35.6 90.4 25.4 8.8 48 17.6 65.4 23.6z"
										fill="#2D94B4" p-id="18140"></path>
									<path
										d="M419.6 307.8c-10.4 0.8-31.4 6-41.8 15.6-33 28.8-13 81.8 54 81.8 39.2 0 78.4-25.2 108.8-64.4-43.6-21.6-81-36.4-121-33z"
										fill="#009FE8" p-id="18141"></path>
									<path
										d="M439.6 434c-86.2 0-114.8-74.8-74.8-124.4 8.8-10.4 24.4-20.8 47.8-27 36.6-8.8 94.8 5.2 149.6 23.4 9.6-18.2 18.2-38.2 24.4-59.2h-168.8v-17.4h87V199h-105.2v-17.4h105.2V138.2s0-7 7.8-7h42.6v50.4h104.4v17.4h-104.4v30.4h85.2c-7.8 33-20.8 63.6-35.6 90.4 26.2 9.6 48.8 18.2 66.2 23.4 61.8 20.8 75.8 21.8 76.6 21.8V143.4c0-38.2-31.4-68.8-68.8-68.8H384c-37.4 0-68.8 30.4-68.8 68.8v292.4c0 38.2 31.4 68.8 68.8 68.8h293.2c38.2 0 68.8-30.4 68.8-68.8v-2.6s-112.2-47-168.8-74c-37.6 46.2-86.2 74.8-137.6 74.8z"
										fill="#009FE8" p-id="18142"></path>
									<path
										d="M720.2 635h125.2v25.2H890v-29.6c0-7-5.2-12.2-11.4-12.2h-72.2v-23.4h-47v23.4h-84.4v42.6h44.4v-26.2h0.8z m-271.4-37.4l-46.2 108.8h35.6v128.8h38.2v-171.4h-14l28.8-66.2h-42.4zM896 830l-14-47.8c-0.8-2.6-3.4-5.2-7-5.2h-37.4l10.4 36.6h-43.6v-70.4h86.2v-16.6h-86.2v-33h86.2v-16.6H675.8v16.6H762v33h-86.2v16.6H762v70.4h-86.2v16.6L896 830z m-356.8-148.8h-33l26.2 81.8h39.2l-24.4-76.6c-1-2.6-4.4-5.2-8-5.2z"
										fill="#050101" p-id="18143"></path>
									<path
										d="M631.4 599.4h-40v41.8h-98.4v16.6h98.4v150.6c0 3.4-3.4 6-6 6h-20v17.4h52.2c7.8 0 14.8-7 14.8-15.6v-158.4h16.6v-16.6h-16.6v-41.8h-1z m-300.2 93s-20.8 82.6-164.4 125.2v20.8s181-34 215-163.6l-48.8 7.8-1.8 9.8z"
										fill="#050101" p-id="18144"></path>
									<path
										d="M233.8 709.8s34.8 62.6 163.6 109.6v19.2S252 809.8 194.6 709.8h39.2z m140.2-17.4H182.4V676h199.2l-7.6 16.4zM168.6 630.6H394v17.4H168.6v-17.4z"
										fill="#050101" p-id="18145"></path>
									<path
										d="M265.2 595.8c-4.4 0-7.8 3.4-7.8 7.8v82.6h47.8v-90.4h-40zM237.4 896l14 41.8h-27.8l13.8-41.8z m18.2 54l7 20h18.2l-36.6-99.2h-14L193.8 970h18.2l7-20h36.6z m84.4-79.2V970h60v-13h-42.6v-86.2H340z m126.2 0h18.2v100h-18.2v-100z m127.8 47h-19.2v-34h20c9.6 0 15.6 8.8 15.6 17.4 0.2 8-5.8 16.6-16.4 16.6z m1-47h-39.2V970h18.2v-38.2h20.8c19.2 0 33-12.2 33-30.4s-12.8-30.6-32.8-30.6z m120 25.2l14 41.8h-27.8l13.8-41.8z m18.2 54l7 20h18.2L722 870h-14l-36.6 100h18.2l7-20h36.6z m125.4-79.2l-19.2 41.8-20-41.8h-19.2l29.6 58.2V970h18.2v-40.8l29.6-58.2h-19z"
										fill="#050101" p-id="18146"></path>
								</svg>
							</div>
						</div>
					</div>

				</div>

			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";

export default {
	name: 'chainEnterprise',
	computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse']),

	},
	data() {
		return {
			curWebsite:this.$api.getWebsiteType(), 
			alipayData: {},
			intervalId: null,//存定时器
			timeoutId: null,
			test: 0,

		}
	},
	beforeCreate() {

	},
	created() {
	},

	mounted() {
		this.getOrderDetail();
		document.title ='在线支付方式';
	},
	beforeDestroy() { //页面销毁时清空定时器，避免反复执行
		// this.stopInterval(); // 清除定时器
	},
	methods: {
		//定时执行
		startInterval() {
			this.intervalId = setInterval(() => {
				this.getOrderDetail();
			}, 6000); // 每6秒请求一次接口
			this.timeoutId = setTimeout(() => { //设置超时定时器
				this.stopInterval();
			}, 30 * 60 * 1000); // 设置30分钟后停止请求

		},
		stopInterval() {
			clearInterval(this.intervalId); // 停止定时器
			clearTimeout(this.timeoutId); // 清除超时定时器
			console.log('停止请求接口');
		},
		//定时获取订单详情，用来判断用户是否支付
		getOrderDetail() {
			var _this = this;
			var ajaxurl = this.$api.free.order.detail() + "?id=" + this.$route.query.id;
			this.$axios.get(ajaxurl).then(function (res) {
				if (res.data.success) {
					console.log('订单详情', res);
					_this.alipayData = res.data.data;
					_this.test++;
					// if (_this.test > 3) {
					// 	_this.stopInterval();
					// 	console.log('订单支付成功');
					// 	_this.routerself('/paysuccess?id=' + _this.$route.query.id);

					// }
					if (res.data.data.isPay) {//判断订单是否支付
						//订单为已支付,关闭定时器不在请求
						_this.stopInterval();
						_this.routerself('/paysuccess?id=' + _this.$route.query.id);
					}
				}
			})
		},
		// getWxpayData() {
		// 	var _this = this;
		// 	var ajaxurl = this.$api.free.wxpay.pay()+"?id="+this.$route.query.id;
		// 	this.$axios.get(ajaxurl).then(function (res) {
		// 		if (res.data.success) {
		// 			// console.log('订单详情', res);
		// 			_this.alipayData = res.data.data;
		// 		} else {

		// 		}
		// 	}).catch(function (error) {
		// 		// 请求失败处理 console.log(error);
		// 	});
		// },
		alipay() {
			window.open(this.alipayData.alipay, '_self');
			this.startInterval();
		},
		wxPay(){
			this.routerself('/wx-pay?id=' + this.alipayData.id)
			this.startInterval();

		}
	}
}
</script>

<style lang="scss" scoped>
.paytype {
	.secessfont {
		font-size: 24px;
		line-height: 84px;
		// padding-top: 30px;
		letter-spacing: 2px;
	}

	.redfont-1 {
		color: #FF2323;
	}

	table {
		font-size: 20px;

		th {
			padding-right: 50px;
			line-height: 44px;
		}
	}

	th {
		background: (0, 0, 0, 0) !important;
	}
}

.bluetitle {
	font-size: 28px;
	font-weight: bold;
	margin: 30px 0 30px 0;
	padding: 40px 50px 30px 50px;
}

.border-bottom {
	border-bottom: 1px solid rgb(226, 226, 226);
}

.wxpay,
.alipay {
	border: 1px solid rgb(199, 199, 199);
	padding: 10px;
	cursor: pointer;

	&:hover {
		border: 1px solid orange;
	}
}
</style>
